import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-isprocessing',
	templateUrl: './isprocessing.component.html',
	styleUrls: ['./isprocessing.component.scss']
})
export class IsProcessingComponent implements OnInit {

	constructor() { }

	ngOnInit(): void {
	}

}
